@if (loading) {
  <app-loader></app-loader>
}

<ol class="breadcrumb">
  <li class="breadcrumb-item active">Organizations</li>

  <li class="breadcrumb-item">
    <a href="#" (click)="openNewHospitalModal()">
      <app-icon icon="plus" iconClass="button-icon"></app-icon> Add Organization
    </a>
  </li>
</ol>

<div class="row">
  <div class="col-xs-12">
    <p-table
      [value]="hospitals"
      selectionMode="single"
      [(selection)]="selectedHospital"
      (onRowSelect)="onRowSelect($event)"
      (onRowUnselect)="null"
      [paginator]="true"
      [rows]="10"
      (onRowSelect)="onRowSelect($event)"
      stateStorage="session"
      stateKey="state-session"
      >
      <ng-template pTemplate="header">
        <tr>
          @for (key of keys; track key) {
            <th pSortableColumn="{{ key }}" [style.width]="tableConfig.columns[key].width">
              {{ tableConfig.columns[key].title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
            </th>
          }
        </tr>
        <tr>
          @for (key of keys; track key) {
            <th style="width:22%">
              <p-columnFilter
                type="text"
                field="{{key}}"
                placeholder="{{tableConfig.columns[key].title}}"
                ariaLabel="Filter {{tableConfig.columns[key].title}}"
                />
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-hospital>
        <tr [pSelectableRow]="hospital">
          @for (key of keys; track key) {
            <td>{{ hospital[key] }}</td>
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
